import FormatTimeViewModel from './FormatTimeViewModel.js';
export default class RefTimeViewModel extends FormatTimeViewModel {
  constructor() {
    super();
    this.refTime = null;
  }
}